import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEOHead from "@/components/app/SEOHead";
import CityFitsQuiz from "@/components/app/CityFitsQuiz";

// Standalone page for the 60-second city quiz (same widget as the home page module).
export default function CityQuizPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10" data-testid="city-quiz-page">
      <SEOHead
        title="60-second city quiz · WhichUniversityAdvisor"
        description="Answer a few quick questions and see which student cities fit your budget and lifestyle."
        path="/city-quiz"
      />
      <Link to="/cities/matcher" data-testid="city-quiz-back-to-places"
        className="inline-flex items-center gap-1 text-[13px] text-stone-500 hover:text-stone-800 mb-4">
        <ArrowLeft className="w-4 h-4" /> Back to Places
      </Link>
      <CityFitsQuiz />
    </div>
  );
}
